// Third-party
import React from 'react';
import classNames from 'classnames';
import Dotdotdot from 'react-dotdotdot';

// Components
import NoDataCell from './NoDataCell';
import { HoldingIcon } from '../common';
import { ParenthesesLabel } from '../misc';

// Utils
import { PROPOSAL_ITEM_PURPOSE } from '../../../modules/proposal/utils/constants';
import ComparisonItemType from '@/types/comparison-item-type';

type Props = {
  value?: string;
  prefix?: string;
  className?: string;
  id?: string;
  currency?: string;
  color?: string;
  type?: ComparisonItemType;
  itemType: ComparisonItemType;
  clamp: number;
  flags?: string[];
};

const ProposalItemLabelCell: React.FunctionComponent<Props> = ({ prefix, clamp = 1, value, className, id, color, type, itemType, currency, flags }: Props) => {
  if (value == null) {
    return <NoDataCell id={id} />;
  }

  const purposeFlag = Object.values(PROPOSAL_ITEM_PURPOSE).find(flag => flags?.includes(flag));
  const localType = type !== undefined ? type : itemType;

  return (
    <div className={classNames('cell proposal-item-label-cell', className)} id={id ? `cell-${id}` : undefined}>
      <span className="markup-container">
        <div className="no-shrink" style={{ '--holding-accent-color': color } as React.CSSProperties}>
          <HoldingIcon type={localType} color={color} className={purposeFlag} />
        </div>

        <div
          className={classNames('item-label', { ellipsis: prefix && clamp === 1, 'font-weight-bold': purposeFlag === PROPOSAL_ITEM_PURPOSE.RECOMMENDED })}
          data-private
          data-dd-privacy="mask"
        >
          {prefix && <span className="prefix">{prefix} </span>}
          {/* Ellipsis is smoother when using the pure CSS solution - only works for single-line text. */}
          {clamp === 1 ? (
            <span className="ellipsis">{value}</span>
          ) : (
            <Dotdotdot useNativeClamp clamp={clamp}>
              <span>{value}</span>
            </Dotdotdot>
          )}{' '}
          {currency && <ParenthesesLabel as="span" text={currency} />}
        </div>
      </span>
    </div>
  );
};

export default ProposalItemLabelCell;
